import { usePriceHelper } from "./PriceHelper";
import { Basket, Product } from "@daalder/types";

const { getListPrice, exclVat, getLowestPriceAsObject } = usePriceHelper();

export default class BasketService {
    /**
     * @todo Term 'advantage' is too vague. Needs to be renamed to better distinguish between different types of discounts.
     * @todo Seems like this should be a computed on the BasketStore.
     */
    calculateAdvantage(cart: Basket) {
        const totalListPrice = getListPrice(cart.subtotal, cart.subtotal.amount);
        let subtotal = exclVat() ? cart.subtotal.original_price_excluding_vat : cart.subtotal.original_price;

        if (subtotal === undefined || subtotal === null || subtotal == "0") {
            subtotal = exclVat() ? cart.subtotal.price_excluding_vat : cart.subtotal.price;
        }

        const advantage = totalListPrice - Number(subtotal);
        return advantage > 0 ? advantage : null;
    }

    /**
     * @todo Term 'old price' is too vague. Needs to be renamed to better distinguish between different types of discounts.
     * @todo Seems like this should be in the PriceHelper composable.
     */
    getTotalProductOldPrice(product: Product, amount: number) {
        return parseFloat(this.getProductOldPrice(product, amount)) * amount;
    }

    /**
     * @todo Term 'old price' is too vague. Needs to be renamed to better distinguish between different types of discounts.
     * @todo Seems like this should be in the PriceHelper composable.
     */
    getProductOldPrice(product: Product, amount = 1) {
        amount = amount === 0 ? 1 : amount;

        let listPrice = getListPrice(product.prices, amount);
        if (listPrice === null || listPrice === undefined) {
            return 0;
        }

        return listPrice;
    }

    /**
     * @todo Seems like this should be in the PriceHelper composable.
     */
    getProductOriginalPrice(product: Product, amount: number = 1) {
        amount = amount === 0 ? 1 : amount;

        let price = getLowestPriceAsObject(product.prices, amount);
        price = exclVat() ? price?.original_price_excluding_vat : price?.original_price;

        if (price === null || price === undefined || price == 0) {
            return 0;
        }

        return price;
    }
}
